import React, {Component} from "react"
import PropTypes from "prop-types"

import {H4} from "@irati/ui/src/Typography/Heading"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import authentication from "@irati/auth"

import {Bold} from "../../Polls/ClosedPoll/styled/Card"

class VoteTitle extends Component {
  static propTypes = {
    vote: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
  }

  render() {
    const {vote, intl} = this.props

    const youSentVote = vote.createdById === authentication.user().uuid

    const userWhoReceivedVote = youSentVote
      ? firstnameLastname(vote.user)
      : intl.formatMessage({id: "recognition.account.recognition.votes.you"})
    const userWhoSentVote = youSentVote
      ? intl.formatMessage({id: "recognition.account.recognition.votes.you"})
      : firstnameLastname(vote.createdBy)

    return (
      <H4>
        <Bold>{userWhoReceivedVote}</Bold> <FormattedMessage
          id="recognition.account.recognition.votes.receivedVote"
          values={{pollName: vote.poll.title, userWhoSentVote}} />
      </H4>
    )
  }
}

export default injectIntl(VoteTitle)
